import * as React from "react";
import { _MasterDetailView, } from "../generic/master-detail-view/MasterDetailView";
import { DetailViewMarket } from "./DetailViewMarket";
import { MasterViewMarket } from "./MasterViewMarket";
export var TabMarket = function () {
    var MasterDetailView = _MasterDetailView;
    return React.createElement(MasterDetailView, { masterRenderer: MasterViewMarket, detailRenderer: DetailViewMarket });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/TabMarket.tsx
// module id = 2711
// module chunks = 3